import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/index'
import Recharge from '@/page/recharge'
import About from '@/page/about'
import PaySuccess from '@/page/paysuccess'
import MobilIndex from '@/mobilPage/index'
import MobilRecharge from '@/mobilPage/recharge'
import MobilPaySuccess from '@/mobilPage/paysuccess'
import Privacy from '@/mobilPage/privacy_qbt'
import UploadMusic from '@/page/upload_music'
import Marketing from '@/mobilPage/marketing.vue'
import MobilRecharging from '@/mobilPage/rechargePage'

Vue.use(Router)
export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/recharge',
      name: 'Recharge',
      component: Recharge
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/paysuccess',
      name: 'PaySuccess',
      component: PaySuccess
    },
    {
      path: '/mobilindex',
      name: 'MobilIndex',
      component: MobilIndex
    },
    {
      path: '/mobilrecharge',
      name: 'MobilRecharge',
      component: MobilRecharge,
      meta: {
        title: '支付宝充值'
      }
    },
    {
      path: '/marketing',
      name: 'Marketing',
      component: Marketing,
      meta: {
        title: ''
      }
    },{
      path: '/wxh5/mobilrecharging',
      // path: '/',
      name: 'MobilRecharging',
      component: MobilRecharging,
      meta: {
        title: '手机充值'
      }
    },
    {
      path:'/privacy',
      name:'Privacy',
      component: Privacy,
      meta: {
        title: '恋爱物语隐私保护指引'
      }
    },
    {
      path: '/mobilpaysuccess',
      name: 'MobilPaySuccess',
      component: MobilPaySuccess
    },
    {
      path:'/upload_music',
      name:'UploadMusic',
      component: UploadMusic
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js